/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import ouiStyle from '@goldwasserexchange/oui-style';
var style = {
    display: ouiStyle.Constants.DisplayProp.flex,
    justifyContent: ouiStyle.Constants.JustifyContentProp.center,
};
var css = ouiStyle.mediaQuery(ouiStyle.makeCss(style));
export var SocialEmbedWrapper = function (props) {
    var children = props.children;
    return (jsx("div", { css: css }, children));
};
